module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAVElEQVQ4T63MyQ0AEBAAQE9l0pEStKQidiUkjj0cj/mOsT4FkD9xBiIUP4QOrxa+pjWbw9u0Z7vwNB0yKtSmS8aFUrrNpJBKyUwTzimbacOWihmGBSvlWPaeCH2nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/triangle.png
// module id = 5b1y
// module chunks = 52